import React from 'react';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import MoreCriteriaCheckbox from './Inputs/MoreCriteriaCheckbox';

const MoreCriteria = () => {
  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Plus de critères' tab='moreCriteria'/>

      <Dropdown tab='moreCriteria'>
        <MoreCriteriaCheckbox />
      </Dropdown>
    </div>
  )
};

export default MoreCriteria;
